import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userNotificationApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) =>
      userNotificationApiClient.markRead(notificationId, {}),
    onSettled: () => invalidateFor('userNotification.read', qc),
  });
}

/** Marks every notification for a post read; the post id overrides the notification id. */
export function useForceReadPostNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (postId: string) =>
      userNotificationApiClient.forceRead(postId, { postId }),
    meta: { silent: true },
    onSettled: () => invalidateFor('userNotification.read', qc),
  });
}
